import React from 'react';
import './airlineOperation.css';

import AboutCity from './about-city';

const AboutAirline = props => {
  return <AboutCity {...props} />;
};

export default AboutAirline;
